/**
 * CSV generado en cliente pensado para Excel en español:
 * BOM UTF-8 + separador ';' + saltos CRLF. Las celdas con ';', comillas o saltos
 * de línea van entrecomilladas; las que empiezan por =, +, -, @ llevan un espacio
 * delante para que Excel no las interprete como fórmula.
 */
const SEP = ";";

function escapeCell(value) {
	if (value === null || value === undefined) return "";
	let s = String(value);
	if (/^[=+\-@\t\r]/.test(s)) s = ` ${s}`;
	if (/[";\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
	return s;
}

export function toCsv(headers, rows) {
	const lines = [headers, ...rows].map(r => r.map(escapeCell).join(SEP));
	return `﻿${lines.join("\r\n")}`;
}

export function safeFileName(name) {
	return String(name || "daruma").replace(/[^a-z0-9-_]/gi, "_");
}

/** Descarga un CSV abriendo un <a> temporal. */
export function downloadCsv(fileName, headers, rows) {
	const blob = new Blob([toCsv(headers, rows)], {
		type: "text/csv;charset=utf-8"
	});
	const url = window.URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = fileName;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	window.URL.revokeObjectURL(url);
}

/** Fecha legible para Excel: dd/mm/aaaa hh:mm */
export function csvDate(value) {
	if (!value) return "";
	const d = new Date(value);
	if (Number.isNaN(d.getTime())) return "";
	const pad = n => String(n).padStart(2, "0");
	return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(
		d.getHours()
	)}:${pad(d.getMinutes())}`;
}
